export class InsertLayerINModel {
    flgEsistente: boolean
    inIdLayer: number
    inIdProgetto: number
    valGeoLay: string
    uid: number
}